// store/modules/video_player.js
import {secureStorage} from "@/services/secureStorage";

export default {
    namespaced: true,
    state: () => ({
        athleteId: JSON.parse(secureStorage.getItem('athleteId')) || null,
    }),
    mutations: {
        setAthleteId(state, id) {
            state.athleteId = id;
            secureStorage.setItem('athleteId', id); // Almacena el athleteId en secureStorage
        },
        resetAthleteId(state) {
            state.athleteId = null;
            secureStorage.removeItem('athleteId'); // Elimina el athleteId en secureStorage
        },
    },
    actions: {

    },
    getters: {

    }
};
